import { render } from "./ComparisonTable.vue?vue&type=template&id=3bffca88&scoped=true"
import script from "./ComparisonTable.vue?vue&type=script&lang=ts"
export * from "./ComparisonTable.vue?vue&type=script&lang=ts"

import "./ComparisonTable.vue?vue&type=style&index=0&id=3bffca88&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3bffca88"

export default script